export const CAMPAIGN_TEMPLATES_FETCH_REQUEST = 'CAMPAIGN_TEMPLATES_FETCH_REQUEST';
export const CAMPAIGN_TEMPLATES_FETCH_SUCCESS = 'CAMPAIGN_TEMPLATES_FETCH_SUCCESS';
export const CAMPAIGN_TEMPLATES_FETCH_FAILURE = 'CAMPAIGN_TEMPLATES_FETCH_FAILURE';

export const FAVORITE_CAMPAIGN_TEMPLATES_FETCH_REQUEST = 'FAVORITE_CAMPAIGN_TEMPLATES_FETCH_REQUEST';
export const FAVORITE_CAMPAIGN_TEMPLATES_FETCH_SUCCESS = 'FAVORITE_CAMPAIGN_TEMPLATES_FETCH_SUCCESS';
export const FAVORITE_CAMPAIGN_TEMPLATES_FETCH_FAILURE = 'FAVORITE_CAMPAIGN_TEMPLATES_FETCH_FAILURE';

export const CAMPAIGN_TEMPLATE_FETCH_REQUEST = 'CAMPAIGN_TEMPLATE_FETCH_REQUEST';
export const CAMPAIGN_TEMPLATE_FETCH_SUCCESS = 'CAMPAIGN_TEMPLATE_FETCH_SUCCESS';
export const CAMPAIGN_TEMPLATE_FETCH_FAILURE = 'CAMPAIGN_TEMPLATE_FETCH_FAILURE';

export const CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_REQUEST = 'CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_REQUEST';
export const CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_SUCCESS = 'CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_SUCCESS';
export const CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_FAILURE = 'CAMPAIGN_TEMPLATES_CATEGORIES_FETCH_FAILURE';

export const maxTemplatesToDisplay = 16;
export const campaignTitleCharLimit = 38;